import { Button } from "antd";
const ModalFooter = ({ currentStep, visibleSteps, onPrev, onNext, onSave, canProceed, loading }) => {
  const lastStepKey = visibleSteps[visibleSteps.length - 1].key;
  return (
    <div style={{ display: "flex", justifyContent: "space-between", marginTop: 24 }}>
      <Button
        onClick={onPrev}
        disabled={currentStep === 0}
        size="large"
      >
        Atrás
      </Button>
      {currentStep < lastStepKey ? (
        <Button
          type="primary"
          onClick={onNext}
          disabled={!canProceed}
          size="large"
        >
          Siguiente
        </Button>
      ) : (
        <Button
          type="primary"
          onClick={onSave}
          disabled={!canProceed}
          loading={loading}
          size="large"
          style={{ minWidth: 140 }}
        >
          {loading ? "Guardando..." : "Guardar Llamada"}
        </Button>
      )}
    </div>
  );
};

export default ModalFooter;